import React from 'react';
import Form from './Form';
import InactiveBg from '../components/InactiveBg';
import axios from 'axios';

// component public api
export default class ArticleEditor extends React.Component {
  state = {
    show: false,
    form: {},
  };

  close = () => {
    this.setState({
      show: false
    });
  };

  show = (form) => {
    this.setState({
      show: true,
      form
    });
  };

  render() {
    const { show, form } = this.state;

    if (!show) return null;

    return <ArticleEditorPrivate {...this.props} close={this.close} initProps={form} />;
  }
}

// eslint-disable-next-line react/no-multi-comp
class ArticleEditorPrivate extends React.Component {
  onSubmit = (e, model) => {

    var url = '/p2p/' + this.props.initProps.campaignId + '/novinky/';

    model.articleId = this.props.initProps.articleId;
    document.getElementById('loading').style.display = "block";
    axios.post(url, model).then((response) => {

      window.location.reload();
      // debugger
      // const { close } = this.props;
      // close();
    }).catch((error) => {
      document.getElementById('loading').style.display = "none";
      app.features.notification('.js-notification', {
        text: 'Novinka nebola uložená',
        status: 'error'
      });
    });


  };

  onCancel = (e) => {
    e.preventDefault();

    const { close } = this.props;
    close();
  };

  render() {
    const { initProps } = this.props;

    return (
      <InactiveBg>
        <Form
          fields={initProps}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
        />
      </InactiveBg>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/articleEditor/index.js